import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { InvoiceDigestStatus } from 'anchor-scout-common/types';
import { SummaryTable } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { routes } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import { invoiceStatusToColor } from './invoicesDigest.utils';
import { getDigestStatusLink } from './InvoicesDigestWIdget.utils';
export const GetInvoicesInfoTableTID = (parentTestId)=>getTestIds(parentTestId);
const invoicesDigestTableTextsPath = 'home.dashboard.invoicesDigestWidget';
export function InvoicesInfoTable(param) {
    let { invoiceDigestModel } = param;
    const { t } = useLocaleKeys(invoicesDigestTableTextsPath);
    const { InvoicesInfoTableTID } = useMemo(()=>GetInvoicesInfoTableTID(), []);
    const statusLabels = {
        [InvoiceDigestStatus.RequiresClientApproval]: t.statusLabels.clientApprovalRequired(),
        [InvoiceDigestStatus.PaymentsVerificationRequired]: t.statusLabels.paymentsVerificationRequired(),
        [InvoiceDigestStatus.MissingPaymentMethod]: t.statusLabels.missingPaymentMethod(),
        [InvoiceDigestStatus.Failed]: t.statusLabels.failed(),
        [InvoiceDigestStatus.Disputed]: t.statusLabels.disputed(),
        [InvoiceDigestStatus.PaymentStopped]: t.statusLabels.paymentStopped(),
        [InvoiceDigestStatus.PaymentMethodUnverified]: t.statusLabels.paymentMethodUnverified()
    };
    const items = invoiceDigestModel.invoiceTypesToDisplay().map((invoiceType)=>{
        const group = invoiceDigestModel.invoiceTypeToInvoicesGroup(invoiceType);
        return {
            id: invoiceType,
            type: statusLabels[invoiceType],
            count: group.count.toString(),
            amount: group.amount.amount()
        };
    });
    const columns = [
        {
            type: 'text',
            name: 'type',
            header: t.tableHeaders.type(),
            // WHY: on a phone the label gives way, truncating, so the three columns fit the widget's width.
            width: {
                initial: 260,
                min: 100
            },
            dotColor: (row)=>invoiceStatusToColor[row.id]
        },
        {
            type: 'text',
            name: 'count',
            header: t.tableHeaders.invoices(),
            width: {
                initial: 90,
                min: 60
            },
            hAlign: 'end'
        },
        {
            type: 'money',
            name: 'amount',
            header: t.tableHeaders.amount(),
            // WHY: an amount never truncates: 100px fits up to $999,999.99, and the floor keeps it when a phone squeezes the widget.
            width: {
                initial: 100,
                min: 100
            },
            hAlign: 'end'
        }
    ];
    return /*#__PURE__*/ _jsx(SummaryTable, {
        columns: columns,
        items: items,
        getRowId: (row)=>row.id,
        rowHref: (row)=>getDigestStatusLink(routes.invoicesDashboard, row.id),
        verticalOverflow: "scroll",
        testId: InvoicesInfoTableTID.Table()
    });
}
